import {LightBoxImage} from "./LightBoxImage";
import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {useGotoTitleSearch} from "../hooks/useGotoTitleSearch";
import {useIsInViewport} from "../hooks/useIsInViewport";
import {awardToText} from "../../data/data";

export const ImageInfo = ({title, textColor, finishedLoaded}) => {
    const ref = useRef(null);
    const refStart = useRef(null);
    const gotoTitleSearch = useGotoTitleSearch({title});
    const isInViewport = useIsInViewport(ref);

    useEffect(() => {
        const hash = window.location.hash.replace("#", "");
        if (hash === title.imageId && !isInViewport) {
            refStart?.current?.scrollIntoView({behavior: 'smooth', block: 'end'});
        }
    }, [refStart.current, finishedLoaded])

    useEffect(() => {
        if (isInViewport) {
            // Need to postpone it until finished scrolling
            // document.location.replace(`${document.location.pathname.split("#")}#${title.imageId}`)
        }

    }, [isInViewport])

    const getAwardText = () => {
        if (title.award === "5" && title.short === "Klubb-NM") {
            return "Utvalgt";
        }
        return awardToText[title.award];
    };

    return <section ref={refStart} id={title.imageId}>
        <ImageStyled textColor={textColor}>
            <LightBoxImage title={title}/>
            <div onClick={() => gotoTitleSearch()}>{getAwardText()}</div>
            <div onClick={() => gotoTitleSearch()}>{title.title}</div>
            <div onClick={() => gotoTitleSearch()}>{title.name}</div>
            <div ref={ref} onClick={() => gotoTitleSearch()}>{title.club}</div>
            {title?.comment && <div>{title.comment}</div>}
        </ImageStyled>
    </section>
}

const ImageStyled = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Fibon Neue';
  
  > div {
    cursor: pointer;
    color: ${(p) => p?.textColor ? p.textColor : "black"};
  }
  

  > img {
    max-height: calc(100vh - 200px);
    max-width: 100vw !important;
    margin-bottom: 10px;
    cursor: pointer;
  }

  > div:nth-child(1) {
    font-size: 2rem;
    line-height: 2.5rem;
  }

  > div:nth-child(2) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  > div:nth-child(3) {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: bold;
  }

  > div:nth-child(4) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  
  >div:nth-child(6) {
    margin-top: 10px;
    width: 300px;
  }

  opacity: 0;
  animation: fadeIn 500ms ease forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`